import { connect } from 'react-redux'
import SolutionGrid from './SolutionGrid'
import { gotoQuestion } from "../../../actions/exam";


const mapStateToProps = (state, ownProps) => {
  return {
    questions: state.exam.questions,
    choices: state.exam.choices,
    currentQuestion: state.exam.currentQuestion
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    goToQuestion: index => dispatch(gotoQuestion(index))
  };
};

const SolutionGridContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SolutionGrid);

export default SolutionGridContainer
